/* eslint-disable react-hooks/exhaustive-deps */
import {
  AlertTost,
  CustomInput,
  CustomModal,
  CustomPhoneInput,
  CustomTable,
  FilterBar,
  RowAction,
} from "#components";
import useGet from "#hooks/useGet.js";
import { AdminLayout, TableLayout } from "#layouts";
import ENDPOINTS from "#services/endPoints.js";
import QUERY_KEYS from "#services/queryKeys.js";
import { agronomistTableHeader } from "#utils/seeds.js";
import { useEffect, useState } from "react";
import { useFormik } from "formik";
import { agronomistInitialValues } from "#validations/initialValues.js";

import usePost from "#hooks/usePost.js";
import useDelete from "#hooks/useDelete.js";
import usePut from "#hooks/usePut.js";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AdminRoutePath } from "#routes/routePath.jsx";
import { addAgronomistDetails } from "#redux/feature/agronomistSlice.js";
import CustomAlert from "../../components/CustomAlert";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { agronomistValidationSchema } from "#validations/validationSchema.js";

export default function AgronomistManagement() {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [dataCount, setDataCount] = useState(10);
  const [searchInput, setSearchInput] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [agronomistDetails, setAgronomistDetails] = useState(null);
  const [dragging, setDragging] = useState(false);
  const [statusLoadingId, setStatusLoadingId] = useState(null);

  const [open, setOpen] = useState({
    add: false,
    edit: false,
  });

  const onOpen = (key, id, data) => {
    setOpen({ ...open, [key]: true });
    setAgronomistDetails(data);
  };

  const onClose = (key) => {
    setOpen({
      ...open,
      [key]: false,
    });
    setAgronomistDetails(null);
    resetForm();
  };

  const {
    data: agronomistListData,
    isLoading: isAgronomistLoading,
    refetch: refetchAgronomistList,
  } = useGet(
    ENDPOINTS.AGRONOMISTS_LISTING,
    QUERY_KEYS.AGRONOMISTS_LISTING_QUERY_KEY,
    {
      page: currentPage.toString(),
      limit: dataCount,
      search: searchInput,
    }
  );

  const {
    mutateAsync: editAgronomistMutateAsync,
    isLoading: isLoadingEditAgronomist,
  } = usePut(ENDPOINTS.AGRONOMISTS_EDIT, QUERY_KEYS.AGRONOMISTS_EDIT_QUERY_KEY);

  const {
    mutateAsync: statusAgronomistMutateAsync,
    isLoading: isLoadingStatusAgronomist,
  } = usePut(
    ENDPOINTS.AGRONOMISTS_STATUS,
    QUERY_KEYS.AGRONOMISTS_STATUS_QUERY_KEY
  );
  const {
    mutateAsync: addAgronomistMutateAsync,
    isLoading: isLoadingAddAgronomist,
  } = usePost(ENDPOINTS.ADD_AGRONOMISTS, QUERY_KEYS.ADD_AGRONOMISTS_QUERY_KEY);

  const { mutateAsync: deleteAgronomistMutateAsync } = useDelete(
    ENDPOINTS.AGRONOMISTS_DELETE,
    QUERY_KEYS.AGRONOMISTS_DELETE_QUERY_KEY
  );

  // const customValidate = (values) => {
  //   const errors = {};

  //   // Check if agronomistFile is provided
  //   if (!values.agronomistFile) {
  //     if (!values.email) errors.email = "Email is required*";
  //     if (!values.firstName) errors.firstName = "First name is required*";
  //     if (!values.lastName) errors.lastName = "Last name is required*";
  //     if (!values.phoneNumber) errors.phoneNumber = "Phone number is required*";
  //     if (!values.location) errors.location = "Location is required*";
  //   } else {
  //     // Clear errors when agronomistFile is provided
  //     if (values.email) delete errors.email;
  //     if (values.firstName) delete errors.firstName;
  //     if (values.lastName) delete errors.lastName;
  //     if (values.phoneNumber) delete errors.phoneNumber;
  //     if (values.location) delete errors.location;
  //   }

  //   return errors;
  // };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: agronomistInitialValues,
    validationSchema: agronomistValidationSchema,
    // validate: customValidate,
    onSubmit: async (values) => {
      try {
        const data = {
          AgronomistId: agronomistDetails?._id,
          email: values.email,
          firstName: values.firstName,
          lastName: values.lastName,
          countryCode: values.countryCode,
          phoneNumber: values.phoneNumber,
          location: values.location,
        };
        if (open.add) {
          try {
            const response = await addAgronomistMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("add");
            refetchAgronomistList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        } else {
          try {
            const response = await editAgronomistMutateAsync(data);
            AlertTost(response?.message, "success");
            resetForm();
            onClose("edit");
            refetchAgronomistList();
          } catch (error) {
            toast.dismiss();
            AlertTost(error?.response?.data?.message, "error");
          }
        }
      } catch (error) {
        AlertTost("Something went wrong", "error");
      }
    },
  });
  useEffect(() => {
    if (open.edit) {
      setValues({
        firstName: agronomistDetails?.firstName,
        lastName: agronomistDetails?.lastName,
        countryCode: agronomistDetails?.countryCode,
        phoneNumber: agronomistDetails?.phoneNumber,
        location: agronomistDetails?.location,
        email: agronomistDetails?.email,
      });
    }
    if (searchInput === "") {
      refetchAgronomistList();
    }
  }, [open.edit, searchInput]);

  // Handle count input change
  const onDataCountChange = (e) => {
    setDataCount(e.target.value);
    setCurrentPage(1);
  };

  //onSearch button
  const onSearchButtonClick = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    refetchAgronomistList();
  };

  //onSearch Change
  const onSearchChange = (e) => {
    setSearchInput(e.target.value);
  };

  useEffect(() => {
    refetchAgronomistList();
  }, [dataCount, currentPage]);

  const handleDeleteAgronomist = async (agronomistId) => {
    CustomAlert({
      title: " Are you sure you  want to delete the agronomist?",
      confirmButtonText: "Confirm",
      icon: "question",
      onConfirm: async () => {
        try {
          await deleteAgronomistMutateAsync({
            agronomistId: agronomistId,
          }).then((response) => {
            AlertTost(response?.message, "success");
            refetchAgronomistList();
          });
        } catch (error) {
          Swal.fire({
            title: "Error",
            text: error?.response?.data?.message,
            icon: "error",
            timer: 2000,
            showConfirmButton: false,
          });
        }
      },
    });
  };

  const handleStatusOnChange = async (item) => {
    try {
      setStatusLoadingId(item._id); // set loading for this row
      await statusAgronomistMutateAsync({
        AgronomistId: item?._id,
      });
      await refetchAgronomistList(); // ensure list is updated after mutation
    } catch (error) {
      console.error("Failed to update status:", error);
      // optionally show a toast or alert
    } finally {
      setStatusLoadingId(null); // remove loading state
    }
  };

  // Pagination function
  const handelPageChange = (action) => {
    setCurrentPage((prevPage) => prevPage + (action === "prev" ? -1 : 1));
  };

  // drag and drop

  const handleDragOver = (e) => {
    e.preventDefault();
    if (!dragging) setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFile = e.dataTransfer.files[0];
    if (droppedFile) {
      setFieldValue("agronomistFile", droppedFile);
    }
  };

  const handleFileSelect = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFieldValue("agronomistFile", selectedFile);
    }
  };
  console.log(errors, "errors");

  const handleRemoveFile = () => {
    setFieldValue("agronomistFile", null);
  };
  return (
    <AdminLayout>
      <section className="main-section spacer">
        <div className="container">
          {/* <FilterBar /> */}
          <FilterBar
            onSearchButtonClick={onSearchButtonClick}
            onSearchChange={onSearchChange}
            searchInput={searchInput}
            onChange={onDataCountChange}
            rowLimit={dataCount}
          />
          <div className="table_wrapper_card">
            <div className="row gy-3">
              <div className="col-xl-12">
                <div className="sub-heading flex-box">
                  <h2> Agronomist Listing </h2>
                  <div className="side-content-blk">
                    <button
                      onClick={() => onOpen("add")}
                      className="primary-btn"
                    >
                      Add New Agronomist
                    </button>
                  </div>
                </div>

                <TableLayout
                  tableHeader={agronomistTableHeader}
                  isEmpty={agronomistListData?.data?.list?.length === 0}
                  isLoading={isAgronomistLoading}
                  currentPage={currentPage}
                  totalItems={agronomistListData?.data?.totalItems}
                  onDataCountChange={onDataCountChange}
                  handlePrevPage={() => handelPageChange("prev")}
                  handleNextPage={() => handelPageChange("next")}
                  rowLimit={dataCount}
                >
                  <CustomTable tableHeader={agronomistTableHeader}>
                    {agronomistListData?.data?.list.map((item, index) => {
                      return (
                        <tr key={index} className="cursor-pointer">
                          <td
                            onClick={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                          >
                            {`${item?.firstName} ${item?.lastName}`}
                          </td>
                          <td
                            onClick={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                          >
                            {item?.email}
                          </td>
                          <td
                            onClick={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                          >
                            {item?.location}
                          </td>
                          <td
                            onClick={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                          >
                            <span
                              className={`table-status ${
                                item?.status === "Active"
                                  ? "st-active"
                                  : "st-suspended"
                              }`}
                            >
                              {item?.status === "Active"
                                ? "Active"
                                : "Inactive"}
                            </span>
                          </td>
                          <RowAction
                            activeAction={{
                              edit: true,
                              view: true,
                              delete: true,
                              status: true,
                            }}
                            onEdit={() => onOpen("edit", item.managerId, item)}
                            onDelete={() => handleDeleteAgronomist(item._id)}
                            onView={() => {
                              navigation(AdminRoutePath.AGRONOMIST_DETAIL.path);
                              dispatch(addAgronomistDetails(item));
                            }}
                            onStatus={handleStatusOnChange}
                            isLoading={statusLoadingId === item._id}
                            item={item}
                          />
                        </tr>
                      );
                    })}
                  </CustomTable>
                </TableLayout>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*  Agronomist modal */}
      <CustomModal
        open={open.add || open.edit}
        title={open.add ? "Add New Agronomist" : "Edit Agronomist"}
        actionButtonTitle="Submit"
        onClose={() => onClose(open.add ? "add" : "edit")}
        onSubmit={handleSubmit}
        loading={isLoadingAddAgronomist || isLoadingEditAgronomist}
      >
        <div className="common-modal-form">
          <div className="row gy-4">
            {/* <div className="col-12">
              <div className="mdl_sub_heading mb-3">
                <h2 className="mb-0 fs-6 fw-medium">Upload CSV</h2>
              </div>
              <div
                className="upload_file_wrapper"
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <input
                  type="file"
                  className="d-none"
                  id="fileUpload"
                  onChange={handleFileSelect}
                />
                <label htmlFor="fileUpload">
                  <span className="file_icon">
                    <img src="/assets/images/icon/file-icon.svg" alt="file" />
                  </span>
                  <span>Drag or drop here</span>
                  <span>or</span>
                  <span className="primary_text">Browse</span>
                </label>
              </div>

              {values.agronomistFile && (
                <div className="file_preview">
                  <span className="file_name">
                    {values.agronomistFile.name}
                  </span>
                  <button className="remove_file" onClick={handleRemoveFile}>
                    x
                  </button>
                </div>
              )}
            </div>
            <div className="col-12">
              <div className="text_divider text-center text-uppercase">or</div>
            </div> */}
            <div className="col-lg-6">
              <CustomInput
                label="First name"
                type="text"
                name="firstName"
                placeholder="Enter your first name"
                value={values?.firstName}
                error={errors.firstName}
                touched={touched.firstName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Last name"
                type="text"
                name="lastName"
                placeholder="Enter your last name"
                value={values?.lastName}
                error={errors.lastName}
                touched={touched.lastName}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
            <div className="col-lg-6">
              <CustomInput
                label="Email Address"
                type="text"
                name="email"
                placeholder="Enter your email address"
                value={values?.email}
                error={errors.email}
                touched={touched.email}
                onChange={handleChange}
                onBlur={handleBlur}
                readOnly={open.edit ? true : false}
              />
            </div>
            <div className="col-lg-6">
              <CustomPhoneInput
                label="Phone number"
                error={errors.phoneNumber}
                touched={touched.phoneNumber}
                countryCode={values.countryCode}
                phoneNumber={values.phoneNumber}
                setFieldValue={setFieldValue}
                disabled={open.edit ? true : false}
              />
            </div>

            <div className="col-lg-6">
              <CustomInput
                label="location"
                type="text"
                placeholder="Enter your location"
                name="location"
                value={values?.location}
                error={errors.location}
                touched={touched.location}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            </div>
          </div>
        </div>
      </CustomModal>
    </AdminLayout>
  );
}
